import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-herdeiros',
  templateUrl: './herdeiros.component.html',
  styleUrls: ['./herdeiros.component.scss']
})
export class HerdeirosComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
